import { css, type CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'

export const iconEnabled: CSSObject = {
  color: Color.dark.Surface.A200,
}

export const iconDisabled = css({
  color: Color.dark.Icon.Primary,
})

export const popoverStyles: CSSObject = {
  padding: `${Spacing.M}px ${Spacing.S}px`,
}
